import React,{ Component } from "react";
import { connect } from "react-redux";
import { updateZone } from "../../../actions/actionZones";
import { Row, Col,  Card, CardHeader, Container} from "reactstrap";
import ZoneForm from "../ZoneForm/ZoneForm";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Zone",path:"/zone",isActive: false},
    {name: "UpdateZone",path:"/updatezone",isActive: true},
];

class UpdateZone extends Component{
    render(){
        return (
            <div>  
                <BreadCrumbCompo routes={routes}/>      
                <Row>
                    <Container>
                        <Col sm={{ size: 8, order: 3, offset: 2 }}>
                            <Card className = "user-form-container">
                                <CardHeader>
                                    <i className="fa fa-edit"></i> <strong>Update Deployment Zone</strong>
                                </CardHeader>
                                <ZoneForm
                                    updateZone={this.props.updateZone}
                                    zoneId={this.props.match.params.id}
                                    fromUpdate={true}
                                />
                            </Card>
                        </Col>
                    </Container>
                </Row>
            </div>
        );
    }
}

UpdateZone.propTypes = {
    updateZone: Proptypes.func.isRequired,
    match: Proptypes.object
};

export default connect(state => ({
    zones: state.zones.zones || []
}), 
dispatch => ({
    updateZone: () => dispatch(updateZone())
}))(UpdateZone);